import { render, staticRenderFns } from "./CardContentLoader.vue?vue&type=template&id=db7c28be&scoped=true"
import script from "./CardContentLoader.vue?vue&type=script&lang=js"
export * from "./CardContentLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7c28be",
  null
  
)

export default component.exports